export * from './dashboard-sprots/dashboard-sprots.component';
export * from './list-of-courses/list-of-courses.component';
export * from './list-of-courses/create-event/create-event.component';
export * from './member-ship-list/member-ship-list.component';
export * from './attendence/attendence.component';
export * from './trainers/trainers.component';
export * from './trainers/new-trainer/new-trainer.component';
export * from './trainers/new-trainer/trainer-details/trainer-details.component';
export * from './list-of-courses/event-details/event-details.component'
